import APIRequest from "./APIRequest";

export const createIntent = (params) => {
  return APIRequest.post(`create-intent`, params);
};

export const paymentSuccess = (params) => {
  return APIRequest.post(`success-payment`, params);
};
